import styles from './person-activity-grid.module.scss';
import { useState } from 'react';
import { useTableConfigHook, UseTableHook } from '../../requestUtils';
import { clone, CreateHeaders, flatten, groupBy, HeaderSizeEnum, minuteToHourConverter, SumRows, textHeader } from '@frontend-workspace/react-shared-lib';
import { IPersonActivity } from '../../_models/person-activity';
import { ValueFormatterParams } from 'ag-grid-community';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface PersonActivityGridProps { }

export function PersonActivityGrid(props: PersonActivityGridProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("personActivity");
  const { data: personActivities, getData, onDateChange, dateRange, isLoading, forGroup, onForGroupToggle, productFilter } = UseTableHook<IPersonActivity>(`reports/person-Activity`, { supportForGroup: true });
  const [isCombined, setIsCombined] = useState<boolean>(true);

  const handleIsCombined = (checked: boolean) => {
    setIsCombined(checked)
  };

  const combineLicensesOnPerson = (list: Array<IPersonActivity>): IPersonActivity => {
    const combinedPersonActivity = clone(list[0]);
    combinedPersonActivity.hours = list.reduce((hours, pa) => pa.hours + hours, 0);
    combinedPersonActivity.logons = list.reduce((logons, pa) => pa.logons + logons, 0);
    combinedPersonActivity.licenseNumber = list.length > 1 ? "Alle lisenser" : combinedPersonActivity.licenseNumber;
    return combinedPersonActivity;
  };

  const combineProductsOnPerson = (list: Array<IPersonActivity>): Array<IPersonActivity> => {
    const productGroup = Object.values(groupBy(list, "product")).map((group: any) => combineLicensesOnPerson(group));
    return productGroup;
  };

  const filteredPersonActivities = (isCombined && personActivities.length > 0) ?
    flatten(Object.values(groupBy(personActivities, "person")).map((group: any) => combineProductsOnPerson(group))) :
    personActivities;

  const productRenderer = (params: ValueFormatterParams) => {
    if (params.data.isSummary) return null;
    return `${params.value}`;
  };
  const versionRenderer = (params: ValueFormatterParams) => {
    if (params.data.isSummary || !params.value) return null;
    return `${params.value}`;
  };
  const hoursLoggedOnRenderer = (params: ValueFormatterParams) => {
    if (params.data.isSummary) return null;
    return minuteToHourConverter(params.value * 60, t("standard.noTimeSpent"));
  }

  const headers = CreateHeaders([
    textHeader("person", t("standard.person"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("companyName", t("standard.company"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("email", t("standard.email"), HeaderSizeEnum.EXTRA_LARGE),
    textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("licenseNumber", t("standard.licenseNumber"), HeaderSizeEnum.MEDIUM),
    textHeader("product", t("standard.product"), HeaderSizeEnum.EXTRA_LARGE, { renderer: productRenderer }),
    textHeader("version", t("standard.version"), HeaderSizeEnum.MEDIUM, { renderer: versionRenderer }),
    textHeader("newLicensing", t("standard.newLicensingSystem"), HeaderSizeEnum.MEDIUM),
    textHeader("logons", t("standard.logons"), HeaderSizeEnum.MEDIUM, {
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    }),
    textHeader("hours", t("standard.hoursLoggedOn"), HeaderSizeEnum.MEDIUM, {
      renderer: hoursLoggedOnRenderer,
      cellStyle: { justifyContent: 'right' },
      headerClass: "ag-right-aligned-header",
      summary: SumRows
    })
  ]);

  return (
    <WebkuaTable
      onRefresh={getData}
      isLoading={isLoading}
      headers={headers}
      data={filteredPersonActivities}
      dateRange={dateRange}
      onSetDateRange={onDateChange}
      tableConfig={tableConfig}
      tableFilters={[{
        label: t("standard.showForGroup"),
        checked: forGroup,
        onChange: onForGroupToggle
      }, {
        label: t("personActivityGrid.mergeProductsForUsers"),
        checked: isCombined,
        onChange: handleIsCombined
      }]}
      productsFilter={productFilter}
    />
  )
}

export default PersonActivityGrid;